import React from "react";
import { Button, styled } from "@mui/material";

interface FilterFormProps {
  onSubmit: () => void;
  onReset: () => void;
  disabled: boolean;
  children: React.ReactNode;
}

const FilterFormContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginTop: 6,
});

const ReportFilterForm = ({
  onSubmit,
  onReset,
  disabled,
  children,
}: FilterFormProps) => {
  return (
    <FilterFormContainer>
      {children}
      <Button
        variant="contained"
        color="secondary"
        disabled={disabled}
        onClick={() => onSubmit()}
      >
        Generate
      </Button>
      <Button
        variant="outlined"
        disabled={disabled}
        onClick={() => {
          onReset();
        }}
      >
        Clear
      </Button>
    </FilterFormContainer>
  );
};

export default ReportFilterForm;
